import React from "react";
import {
  List,
  Datagrid,
  TextField,
  DateField,
  FunctionField
} from "react-admin";
import { downloadCSV } from "react-admin";
import { unparse as convertToCSV } from "papaparse/papaparse.min";
import ReactCountryFlag from "react-country-flag";
import Tooltip from '@material-ui/core/Tooltip';
import {UserAccessFilter} from "./filters";

const userAccessExporter = items => {
  const itemsForExport = items.map(item => {
    const { user, email, is_staff, ...restItem } = item;
    if (is_staff) {
      restItem.user = `Staff: ${email}`;
    } else {
      restItem.user = `Doctor: ${email}`;
    }
    restItem.userId = user;

    return restItem;
  });

  const csv = convertToCSV({
    data: itemsForExport,
    fields: ["id", "user", "userId", "access_type", "note", "created"]
  });
  downloadCSV(csv, "user_access");
};

export const UserAccessList = props => {
  return (
    <List
        {...props}
        exporter={userAccessExporter}
        bulkActionButtons={null}
        filters={<UserAccessFilter />}
    >
      <Datagrid>
        <TextField source="id" />
        <FunctionField
          label="User"
          render={record => {
            if (!record.user) return "";
            if (record.is_staff) {
              return <span>Staff: {record.email}</span>;
            }
            return <span>Doctor: {record.email}</span>;
          }}
        />

        <TextField source="access_type" />
        <FunctionField
            label="Admin type"
            render={record => {
                let admin_type = 'main-admin';
                if (record.admin_type === 'w') {
                    admin_type = 'doctor-admin';
                }
                return <span>{admin_type}</span>
            }}
            />
        <TextField source="note" />
        <TextField source="ip_address"/>
        <FunctionField
            label="Country"
            render={record => {
              if (!record.ip_address || !record.country || !record.country.country_code) return "-";
                return(
                    <Tooltip
                        title={record.country.country_name}
                        aria-label={record.country.country_name}
                        placement="top"
                    >
                        <ReactCountryFlag
                            countryCode={record.country.country_code}
                            svg
                            cdnUrl="https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/1x1/"
                            cdnSuffix="svg"
                            aria-label={record.country.country_name}
                            alt={record.country.country_name}
                            style={{
                                width: '1.5rem',
                                heigth: '1rem',
                            }}
                        />
                    </Tooltip>);
            }}
        />
          <DateField source="created" showTime />
      </Datagrid>
    </List>
  );
};
